<template>
    <Select
        v-model="selectedCountryCode"
        :options="countries"
        :virtual-scroller-options="{ itemSize: 33 }"
        option-label="name"
        option-value="code"
        fluid
    >
        <label>Land</label>
        <template #option="slotProps">
            <div :data-cy="slotProps.option.code">{{ slotProps.option.name }}</div>
        </template>
        <template #value="slotProps">
            <div v-if="slotProps.value">{{ countryName(slotProps.value) }}</div>
        </template>
    </Select>
</template>

<script setup lang="ts">
import {Select} from 'primevue'

const selectedCountryCode = defineModel({
    type: String,
    default: 'NO'
})

type Country = {
    code: string,
    name: string
}

const getCountries = (lang: string = 'no'): Country[] => {
    const A = 65
    const Z = 90
    const countryName = new Intl.DisplayNames([lang], {type: 'region'})
    const seen = new Set<string>()
    const countries = []
    for (let i = A; i <= Z; ++i) {
        for (let j = A; j <= Z; ++j) {
            const code = String.fromCharCode(i) + String.fromCharCode(j)
            const name = countryName.of(code)
            if (code !== name && name && !seen.has(name)) {
                seen.add(name)
                countries.push({code, name})
            }
        }
    }
    return countries.sort((a, b) => a.name.localeCompare(b.name, lang))
}

const countries = getCountries()

const countryName = (code: string) => countries.find(c => c.code === code)?.name ?? code

</script>

<style scoped>

</style>
